var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-filter-value',{attrs:{"date":_vm.date,"format":_vm.format},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('date-from-icon',{staticClass:"mb-1"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }